import { React, useRef } from "react";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
import { FaGithubSquare } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";


const Contact = () => {
  
  return (
    <section className="contact" id="contact">
      <div className="container pt-8">
        <div className="about-me-text mt-5 text-center position-relative">
          <h1 className="position-absolute know-text">Get In Touch</h1>
          <h1 className="about-me-txt text-muted">contact</h1>
        </div>

        <div className="row mt-5">
          <div className="col-md-4 mt-4 text-light">
            <h2 className="text-light">Contact Details</h2>

            <p className="text-light mt-3 text-1">
              <a href="tel: 8688284092">
                <BsFillTelephoneFill />
                &nbsp; +91 8688284092
              </a>
            </p>
            <p className="text-1 mt-2 text-light">
              <a href="mailto:mohdafeefali080@gmail.com">
                <FiMail />
                &nbsp; mohdafeefali080@gmail.com
              </a>
            </p>
            <p style={{ fontSize: "22px" }} className="text-light">
              Hyderabad,India
            </p>

            <div className="media mt-5">
              <h3 className="text-light">FOLLOW ME</h3>
              <div
                className="icons-media mt-3 d-flex text-muted"
                style={{ gap: "20px" }}
              >
                <a href="https://github.com/Afeef03" target="_blank">
                  <FaGithubSquare />
                </a>
                <a
                  href="https://www.linkedin.com/in/afeef-ali-b63a2b25a"
                  target="_blank"
                >
                  <AiFillLinkedin />
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-8 mt-4">
            <form method="post" action="/">
              <div className="row g-4">
                <div className="col-lg-6">
                  <input type="text" placeholder="Name" name="user_name" />
                </div>
                <div className="col-lg-6">
                  <input type="email" name="user_email" placeholder="Email" />
                </div>
                <div className="col" id="text-col">
                  <textarea
                    name="message"
                    className="w-100"
                    id=""
                    placeholder="Tell Us About Yourself......."
                    cols="30"
                  ></textarea>
                  <button className="text-center mt-4 send-msg">
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
